import { geoCodeAddress } from '../helper';

export default {
  yearEarningsChartData(state) {
    const response = (state.earnings.year.map(item => [item.month.slice(0, 3), parseInt(item.earnings, 10)]));
    return [...[['Month', 'Sales']], ...response];
  },

  monthEarningsChartData(state) {
    const response = (state.earnings.month.map(item => [item.week, parseInt(item.earnings, 10)]));
    return [...[['Month', 'Sales']], ...response];
  },

  weekEarningsChartData(state) {
    const response = (state.earnings.week.map(item => [item.week_day.slice(0, 3), parseInt(item.earnings, 10)]));
    return [...[['Month', 'Sales']], ...response];
  },

  allOrders(state) {
    const response = state.orders.map(item => [item.Month, parseInt(item.month_total, 10)]);
    return [...[['Month', 'Orders']], ...response];
  },

  totalOrders(state) {
    return state.orders.reduce((acc, item) => acc + item.month_total, 0);
  },

  fetchUploadedProductsStats(state) {
    const response = state.products_uploads.map(item => [item.month, parseInt(item.month_total, 10)]);
    return [...[['Month', 'Products']], ...response];
  },

  fetchTopRegions(state) {
    const response = state.top_states.map(item => [item.state, parseInt(item.total_sales, 10)]);
    return [...[['State', 'Region Sales']], ...response];
  },

  totalUploadedProducts(state) {
    return state.products_uploads.reduce((acc, item) => acc + item.month_total, 0);
  },

  totalProductsSold(state) {
    const response = (state.products_sales.map(item => [item.month.slice(0, 3), parseInt(item.product_sold, 10)]));
    return [...[['Month', 'Sales']], ...response];
  },

  totalSalesByLocation(state) {
    return state.sales_location.reduce((acc, item) => acc + parseInt(item.total_sales, 10), 0);
  },
};
